// extracted by mini-css-extract-plugin
export default {"tab":"Tab_tab__PIXH-","tabTitle":"Tab_tabTitle__5pLTo","center":"Tab_center__VKj-5"};